import React from 'react'
import './index.sass'

const Dots = ({
  activeComponent,
  totalComponents,
  chooseSelectedSlide,
}) => {
  const getSelectedClassName = index => {
    if (activeComponent === index) {
      return 'selected'
    }
  }

  const getVisitedClassName = index => {
    if (index <= activeComponent) {
      return 'visited'
    }
  }
  return (
    <div className="pointed-slider">
      {Array(totalComponents + 1)
        .fill(1)
        .map((item, index) => (
          <div key={index} className={'dot ' + getVisitedClassName(index)}>
            <div
              className={'dot-wrapper ' + getSelectedClassName(index)}
              onClick={() => chooseSelectedSlide(index)}
            />
          </div>
        ))}
    </div>
  )
}

export default Dots
